import type { Movie } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "jingqi-conglin",
    title: "激情丛林",
    type: "电视剧",
    year: "2024",
    region: "中国大陆",
    genres: ["都市", "情感", "悬疑"],
    rating: 9.2,
    duration: "45分钟/集",
    episodes: "全40集",
    director: "林越",
    actors: ["沈知远", "苏晚", "陆行舟", "江语晴"],
    intro:
      "一场意外将四位都市男女卷入热带雨林的跨国调查之中，欲望、秘密与真心在潮湿闷热的绿色迷宫里层层揭开。他们在追杀与救赎之间，逐渐认清彼此，也认清自己。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20couple%20standing%20close%20in%20a%20misty%20tropical%20jungle%20at%20golden%20hour%2C%20lush%20deep%20green%20foliage%2C%20dramatic%20warm%20rim%20light%2C%20emotional%20suspense%20mood%2C%20rich%20forest%20green%20and%20amber%20color%20grading%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ultra%20wide%20cinematic%20view%20of%20a%20dense%20tropical%20rainforest%20canopy%20at%20dawn%20with%20volumetric%20light%20rays%20and%20soft%20mist%2C%20deep%20forest%20green%20tones%2C%20atmospheric%20and%20immersive%2C%20moody%20cinematic%20color%20grading%2C%20high%20detail&width=1600&height=900&seq=jqc-back-01&orientation=landscape",
    popularity: 98650,
    updateDate: "2026-10-12",
    featured: true,
  },
  {
    id: "jingqi-conglin-anyong",
    title: "激情丛林·暗涌",
    type: "电视剧",
    year: "2025",
    region: "中国大陆",
    genres: ["悬疑", "都市", "犯罪"],
    rating: 9.0,
    duration: "48分钟/集",
    episodes: "全36集",
    director: "周牧",
    actors: ["陆行舟", "林知夏", "程野", "白清欢"],
    intro:
      "《激情丛林》续作。当雨林深处的旧案重新浮出水面，曾经的同盟开始彼此怀疑。一桩关于金钱、背叛与亲情的暗流，正悄悄吞没所有人的退路。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20suspense%20poster%20of%20a%20lone%20figure%20walking%20through%20a%20dark%20rain%20soaked%20jungle%20path%20at%20night%2C%20deep%20green%20and%20teal%20shadow%20tones%2C%20distant%20warm%20lantern%20glow%2C%20tense%20cinematic%20atmosphere%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20scene%20of%20a%20rain%20soaked%20tropical%20jungle%20with%20glowing%20lanterns%20and%20rolling%20fog%2C%20deep%20green%20and%20teal%20tones%2C%20suspenseful%20moody%20lighting%2C%20high%20detail%20atmospheric%20composition&width=1600&height=900&seq=jqc-back-02&orientation=landscape",
    popularity: 91230,
    updateDate: "2026-10-13",
    featured: true,
  },
  {
    id: "conglin-shenchu",
    title: "丛林深处",
    type: "电影",
    year: "2025",
    region: "中国大陆",
    genres: ["冒险", "剧情"],
    rating: 8.7,
    duration: "128分钟",
    director: "林越",
    actors: ["程野", "苏晚", "孟繁星"],
    intro:
      "一支科考队深入无人雨林寻找珍稀物种，却意外唤醒沉睡多年的秘密。当现代文明遇上原始野性，人心的边界开始崩塌。",
    cover:
      "https://readdy.ai/api/search-image?query=Adventure%20film%20poster%20of%20explorers%20with%20backpacks%20gazing%20into%20a%20vast%20lush%20jungle%20valley%2C%20sunbeams%20through%20tall%20trees%2C%20deep%20green%20and%20warm%20gold%20palette%2C%20epic%20cinematic%20scale%2C%20high%20detail%2C%20vertical%20poster%20composition&width=400&height=600&seq=jqc-movie-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20shot%20of%20an%20ancient%20tropical%20jungle%20valley%20with%20sunbeams%20piercing%20tall%20trees%2C%20misty%20layers%20of%20deep%20green%2C%20warm%20golden%20light%2C%20high%20detail%20immersive%20atmosphere&width=1600&height=900&seq=jqc-back-03&orientation=landscape",
    popularity: 87340,
    updateDate: "2026-10-11",
  },
  {
    id: "lulin-miqing",
    title: "绿林迷情",
    type: "电影",
    year: "2023",
    region: "中国香港",
    genres: ["爱情", "剧情"],
    rating: 8.5,
    duration: "112分钟",
    director: "何知遥",
    actors: ["林知夏", "白清欢"],
    intro:
      "在南方边陲的雨林小镇，两个怀揣秘密的年轻人相遇。潮热的风、说不出口的心事，让这段感情如同藤蔓般缠绕生长。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20of%20two%20young%20lovers%20under%20a%20canopy%20of%20lush%20green%20leaves%20with%20soft%20dappled%20sunlight%2C%20warm%20emotional%20tone%2C%20deep%20green%20and%20blush%20palette%2C%20dreamy%20cinematic%20bokeh%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20wide%20cinematic%20scene%20of%20a%20lush%20green%20forest%20with%20dappled%20sunlight%20and%20warm%20haze%2C%20dreamy%20bokeh%2C%20tender%20emotional%20mood%2C%20high%20detail%20atmospheric%20composition&width=1600&height=900&seq=jqc-back-04&orientation=landscape",
    popularity: 79820,
    updateDate: "2026-09-28",
  },
  {
    id: "redai-xintiao",
    title: "热带心跳",
    type: "电影",
    year: "2024",
    region: "泰国",
    genres: ["爱情", "冒险"],
    rating: 8.3,
    duration: "105分钟",
    director: "Napat S.",
    actors: ["江语晴", "孟繁星", "程野"],
    intro:
      "一次海岛雨林中的生存挑战，让素不相识的旅行者被迫组队。危险让心跳加速，也让两颗心慢慢靠近。",
    cover:
      "https://readdy.ai/api/search-image?query=Tropical%20romance%20adventure%20poster%20of%20two%20travelers%20beside%20a%20waterfall%20in%20a%20vivid%20green%20jungle%2C%20warm%20sunset%20glow%2C%20deep%20green%20and%20coral%20palette%2C%20vibrant%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vibrant%20wide%20cinematic%20jungle%20waterfall%20surrounded%20by%20lush%20green%20foliage%20with%20warm%20sunset%20glow%20and%20mist%2C%20tropical%20adventure%20mood%2C%20high%20detail%20immersive%20composition&width=1600&height=900&seq=jqc-back-05&orientation=landscape",
    popularity: 76510,
    updateDate: "2026-10-02",
  },
  {
    id: "milin-zhuizong",
    title: "密林追踪",
    type: "电视剧",
    year: "2025",
    region: "美国",
    genres: ["悬疑", "惊悚"],
    rating: 8.9,
    duration: "52分钟/集",
    episodes: "全24集",
    director: "Elias Ward",
    actors: ["沈知远", "林知夏", "陆行舟"],
    intro:
      "一名森林巡护员在雨林深处发现了一串不属于任何已知物种的脚印。随着调查深入，一个横跨两代人的惊天秘密逐渐浮现。",
    cover:
      "https://readdy.ai/api/search-image?query=Thriller%20series%20poster%20of%20a%20ranger%20with%20a%20flashlight%20in%20a%20dark%20dense%20jungle%20at%20dusk%2C%20deep%20green%20shadow%20tones%20with%20a%20single%20warm%20light%2C%20tense%20atmospheric%20mood%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20dark%20jungle%20at%20dusk%20with%20deep%20green%20shadows%20and%20a%20single%20warm%20beam%20of%20light%20through%20mist%2C%20tense%20thriller%20atmosphere%2C%20high%20detail%20composition&width=1600&height=900&seq=jqc-back-06&orientation=landscape",
    popularity: 88990,
    updateDate: "2026-10-10",
    featured: true,
  },
  {
    id: "yulin-zhiyue",
    title: "雨林之约",
    type: "电影",
    year: "2022",
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    rating: 8.1,
    duration: "118分钟",
    director: "何知遥",
    actors: ["苏晚", "白清欢"],
    intro:
      "十年前的一个约定，让两个人在雨林边缘重逢。时光改变了他们，却没能冲刷掉那份藏得极深的眷恋。",
    cover:
      "https://readdy.ai/api/search-image?query=Emotional%20romance%20poster%20of%20a%20couple%20reuniting%20on%20a%20wooden%20bridge%20over%20a%20green%20jungle%20river%2C%20soft%20overcast%20light%2C%20muted%20deep%20green%20and%20warm%20beige%20palette%2C%20tender%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Serene%20wide%20cinematic%20jungle%20river%20winding%20through%20lush%20green%20forest%20under%20soft%20overcast%20light%2C%20muted%20green%20and%20warm%20beige%20tones%2C%20tender%20atmospheric%20mood%2C%20high%20detail&width=1600&height=900&seq=jqc-back-07&orientation=landscape",
    popularity: 68340,
    updateDate: "2026-09-20",
  },
  {
    id: "conglin-huixiang",
    title: "丛林的回响",
    type: "电视剧",
    year: "2024",
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.6,
    duration: "46分钟/集",
    episodes: "全32集",
    director: "周牧",
    actors: ["江语晴", "沈知远", "孟繁星"],
    intro:
      "一位植物学家带着女儿重返雨林故乡，寻找母亲留下的研究笔记。两代人的隔阂在潮湿的绿意里慢慢融化。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20poster%20of%20a%20mother%20and%20daughter%20walking%20through%20a%20sunlit%20green%20plant%20filled%20jungle%20path%2C%20gentle%20golden%20light%2C%20deep%20green%20and%20honey%20tones%2C%20heartfelt%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Gentle%20wide%20cinematic%20sunlit%20jungle%20path%20lined%20with%20huge%20tropical%20leaves%2C%20deep%20green%20and%20honey%20gold%20tones%2C%20warm%20hopeful%20atmosphere%2C%20high%20detail%20composition&width=1600&height=900&seq=jqc-back-08&orientation=landscape",
    popularity: 74120,
    updateDate: "2026-10-05",
  },
  {
    id: "yexing-zhiguang",
    title: "野性之光",
    type: "电影",
    year: "2025",
    region: "日本",
    genres: ["奇幻", "剧情"],
    rating: 8.4,
    duration: "120分钟",
    director: "安藤遥",
    actors: ["林知夏", "程野"],
    intro:
      "传说雨林深处有一处会发光的秘境，只有心灵纯净的人才能抵达。一个迷路的少年，在寻找出口的路上找到了自己。",
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20film%20poster%20of%20a%20lone%20boy%20standing%20in%20a%20magical%20glowing%20green%20jungle%20with%20floating%20fireflies%20and%20light%20beams%2C%20ethereal%20deep%20green%20and%20luminous%20teal%20palette%2C%20wonder%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20poster%20composition&width=400&height=600&seq=jqc-movie-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Magical%20wide%20cinematic%20glowing%20jungle%20at%20night%20with%20drifting%20fireflies%20and%20soft%20green%20light%20beams%2C%20ethereal%20deep%20green%20and%20luminous%20teal%20tones%2C%20wonder%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=jqc-back-09&orientation=landscape",
    popularity: 70250,
    updateDate: "2026-10-08",
  },
  {
    id: "conglin-faze",
    title: "丛林法则",
    type: "电视剧",
    year: "2023",
    region: "韩国",
    genres: ["动作", "悬疑"],
    rating: 8.8,
    duration: "50分钟/集",
    episodes: "全28集",
    director: "박준호",
    actors: ["陆行舟", "江语晴", "白清欢"],
    intro:
      "一群被困雨林的陌生人，为了活下去不得不重新制定规则。当秩序崩塌，人性中最真实的一面被彻底放大。",
    cover:
      "https://readdy.ai/api/search-image?query=Intense%20action%20thriller%20poster%20of%20a%20group%20of%20survivors%20standing%20defiant%20in%20a%20dark%20stormy%20jungle%2C%20dramatic%20side%20lighting%2C%20deep%20green%20and%20cold%20steel%20tones%2C%20gritty%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dramatic%20wide%20cinematic%20stormy%20jungle%20with%20dark%20green%20foliage%20and%20rays%20of%20cold%20light%20breaking%20through%20clouds%2C%20gritty%20tension%20atmosphere%2C%20high%20detail%20composition&width=1600&height=900&seq=jqc-back-10&orientation=landscape",
    popularity: 82170,
    updateDate: "2026-09-30",
  },
  {
    id: "wugu-milin",
    title: "雾谷秘林",
    type: "电影",
    year: "2024",
    region: "中国大陆",
    genres: ["悬疑", "剧情"],
    rating: 8.2,
    duration: "116分钟",
    director: "林越",
    actors: ["沈知远", "林知夏"],
    intro:
      "一个终年被浓雾笼罩的山谷，每个进入的人都会遗忘一部分记忆。记者为了寻找失踪的妹妹，踏入了这片致命的秘密之林。",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20film%20poster%20of%20a%20silhouetted%20figure%20at%20the%20edge%20of%20a%20fog%20filled%20green%20valley%20forest%2C%20pale%20mist%2C%20muted%20deep%20green%20and%20grey%20teal%20palette%2C%20eerie%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20poster%20composition&width=400&height=600&seq=jqc-movie-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20fog%20filled%20green%20valley%20with%20tall%20forest%20silhouettes%20fading%20into%20pale%20mist%2C%20muted%20deep%20green%20and%20grey%20teal%20tones%2C%20eerie%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=jqc-back-11&orientation=landscape",
    popularity: 66490,
    updateDate: "2026-09-25",
  },
  {
    id: "tengman-zhijian",
    title: "藤蔓之间",
    type: "电影",
    year: "2022",
    region: "中国台湾",
    genres: ["文艺", "爱情"],
    rating: 7.9,
    duration: "98分钟",
    director: "何知遥",
    actors: ["苏晚", "孟繁星"],
    intro:
      "植物园的温室里，两段截然不同的人生因为一株稀有藤蔓而交织。细腻缓慢的节奏，讲述关于成长与放手的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20romance%20poster%20of%20a%20person%20among%20towering%20green%20hanging%20vines%20inside%20a%20glass%20greenhouse%2C%20soft%20diffused%20light%2C%20muted%20deep%20green%20and%20sage%20palette%2C%20quiet%20poetic%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20poster%20composition&width=400&height=600&seq=jqc-movie-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Serene%20wide%20cinematic%20interior%20of%20a%20glass%20greenhouse%20filled%20with%20towering%20green%20hanging%20vines%20and%20diffused%20light%2C%20muted%20deep%20green%20and%20sage%20tones%2C%20poetic%20quiet%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=jqc-back-12&orientation=landscape",
    popularity: 58230,
    updateDate: "2026-09-15",
  },
  {
    id: "conglin-liange",
    title: "丛林恋歌",
    type: "电视剧",
    year: "2025",
    region: "中国大陆",
    genres: ["爱情", "都市"],
    rating: 8.5,
    duration: "42分钟/集",
    episodes: "全30集",
    director: "周牧",
    actors: ["江语晴", "程野", "白清欢"],
    intro:
      "热带的雨季里，一场真人秀把他们丢进了同一片丛林。镜头之外的真心，比剧本更加动人。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20of%20two%20young%20people%20sheltering%20under%20a%20giant%20green%20leaf%20in%20the%20rain%2C%20warm%20candlelight%20glow%2C%20deep%20green%20and%20warm%20amber%20palette%2C%20intimate%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cozy%20wide%20cinematic%20rain%20scene%20in%20a%20lush%20green%20jungle%20with%20warm%20lantern%20glow%20and%20soft%20bokeh%2C%20deep%20green%20and%20amber%20tones%2C%20intimate%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=jqc-back-13&orientation=landscape",
    popularity: 77860,
    updateDate: "2026-10-13",
    featured: true,
  },
  {
    id: "lüying-mizong",
    title: "绿影迷踪",
    type: "电影",
    year: "2023",
    region: "中国大陆",
    genres: ["悬疑", "冒险"],
    rating: 8.0,
    duration: "110分钟",
    director: "林越",
    actors: ["程野", "林知夏"],
    intro:
      "一张泛黄的老照片，把考古队引向地图上不存在的一片雨林。他们找到的不是宝藏，而是一段被抹去的历史。",
    cover:
      "https://readdy.ai/api/search-image?query=Adventure%20mystery%20poster%20of%20an%20archaeologist%20holding%20a%20lantern%20before%20ancient%20moss%20covered%20green%20ruins%20in%20the%20jungle%2C%20dramatic%20dappled%20light%2C%20deep%20green%20and%20bronze%20palette%2C%20intriguing%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20poster%20composition&width=400&height=600&seq=jqc-movie-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20ancient%20moss%20covered%20stone%20ruins%20hidden%20in%20a%20lush%20green%20jungle%20with%20dramatic%20dappled%20sunlight%2C%20deep%20green%20and%20bronze%20tones%2C%20mysterious%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=jqc-back-14&orientation=landscape",
    popularity: 64120,
    updateDate: "2026-09-18",
  },
  {
    id: "shenhai-lülin",
    title: "深海绿林",
    type: "电影",
    year: "2024",
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.3,
    duration: "132分钟",
    director: "Elias Ward",
    actors: ["沈知远", "陆行舟", "江语晴"],
    intro:
      "当一支深海探险队意外发现海底生长着整片绿色森林，人类对生命的认知被彻底改写。科幻外壳下，是对自然的敬畏。",
    cover:
      "https://readdy.ai/api/search-image?query=Sci%20fi%20adventure%20poster%20of%20a%20diver%20before%20a%20surreal%20glowing%20green%20underwater%20forest%2C%20teal%20and%20emerald%20light%20rays%2C%20deep%20ocean%20and%20lush%20green%20palette%2C%20awe%20inspiring%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Surreal%20wide%20cinematic%20underwater%20glowing%20green%20forest%20with%20teal%20light%20rays%20and%20floating%20particles%2C%20deep%20ocean%20and%20emerald%20tones%2C%20awe%20inspiring%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=jqc-back-15&orientation=landscape",
    popularity: 71540,
    updateDate: "2026-10-06",
  },
  {
    id: "conglin-zhizi",
    title: "丛林之子",
    type: "电视剧",
    year: "2025",
    region: "英国",
    genres: ["剧情", "成长"],
    rating: 8.7,
    duration: "49分钟/集",
    episodes: "全26集",
    director: "Oliver Finch",
    actors: ["白清欢", "孟繁星", "程野"],
    intro:
      "一个在雨林中长大的少年第一次走进城市。他用最原始的方式理解规则、友谊与爱，也让身边的大人重新学会天真。",
    cover:
      "https://readdy.ai/api/search-image?query=Coming%20of%20age%20drama%20poster%20of%20a%20barefoot%20boy%20standing%20amid%20towering%20green%20jungle%20ferns%20and%20sunbeams%2C%20deep%20green%20and%20soft%20gold%20palette%2C%20hopeful%20cinematic%20mood%2C%20high%20detail%2C%20vertical%20film%20poster%20composition&width=400&height=600&seq=jqc-movie-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20towering%20green%20jungle%20ferns%20with%20warm%20sunbeams%20streaming%20through%20the%20canopy%2C%20deep%20green%20and%20soft%20gold%20tones%2C%20hopeful%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=jqc-back-16&orientation=landscape",
    popularity: 69870,
    updateDate: "2026-10-09",
  },
];